export default {
  zh_cn: {
    topicContent: "主题内容描述",
    aiOfTopics: "AI讨论数量",
    talkScene: "Idea Talk 场景",
    meetScene: "智汇研讨场景",
    emergentcurriculum: "生成试卷",
    generateFramework: "生成框架",
    GenerateQuestions: "生成问答题目",
    ActivityFormat: "活动形式",
    Addimage: "添加图片",

    Addfile: "添加文件",
    whethertoenter: "已生成，是否进入？",
    drag: "拖拽文件至此处上传",
    Supportedfile: "支持文件格式：",
    Uploadingfiles: "正在上传文件",
    createActivity: "创建活动",
    noActivity: "未选取任何活动"
  },
  ZH_HK: {
    topicContent: "主題內容描述",
    aiOfTopics: "AI討論數量",
    talkScene: "Idea Talk 場景",
    meetScene: "智匯研討場景",
    emergentcurriculum: "生成試卷",
    generateFramework: "生成框架",
    GenerateQuestions: "生成問答題目",
    ActivityFormat: "活動形式",
    Addimage: "添加圖片",
    Addfile: "添加文件",
    whethertoenter: "已生成，是否進入？",
    drag: "拖拽文件至此處上傳",
    Supportedfile: "支持文件格式：",
    Uploadingfiles: "正在上傳文件",
    createActivity: "创建活動",
    noActivity: "未選取任何活動"
  },

  EN: {
    topicContent: "Topic Content Description",
    aiOfTopics: "No. of AI Discussions",
    talkScene: "Idea Talk Scenario",
    meetScene: "Idea Meet Scenario",
    emergentcurriculum: "Generate test papers",
    generateFramework: "Generate Framework",
    GenerateQuestions: "Generate Q&A Questions",
    ActivityFormat: "Activity Format",
    Addimage: "Add Image",
    Addfile: "Add File",
    whethertoenter: "It has been generated. Would you like to enter?",
    drag: "Drag and drop files here to upload",
    Supportedfile: "Supported file formats:",
    Uploadingfiles: "Uploading files",
    createActivity: "Create Activity",
    noActivity: "No activity selected"
  },
  es: {
    topicContent: "Descripción del contenido temático",
    aiOfTopics: "Número de discusiones con IA",
    talkScene: "Escenario Idea Talk",
    meetScene: "Escenario Idea Meet",
    emergentcurriculum: "Generar Examen de prueba",
    generateFramework: "Generar marco",
    GenerateQuestions: "Generar preguntas de preguntas y respuestas",
    ActivityFormat: "Formato de la actividad",
    Addimage: "Añadir imagen",
    Addfile: "Añadir archivo",
    whethertoenter: "Se ha generado. ¿Desea entrar?",
    drag: "Arrastre los archivos aquí para subirlos",
    Supportedfile: "Formatos de archivo admitidos:",
    Uploadingfiles: "Cargando archivos",
    createActivity: "Crear actividad",
    noActivity: "No se ha seleccionado ninguna actividad"
  }
};
